export default __webpack_public_path__ + "static/media/3022.0c0d6732.jpg";